/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GlobeGridIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Globe Grid',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10,1.25195C5.1748,1.25195,1.25,5.17676,1.25,10.00195s3.9248,8.75,8.75,8.75,8.75-3.9248,8.75-8.75S14.8252,1.25195,10,1.25195ZM17.21094,9.25195h-3.14209c-.1394-2.33032-.91455-4.52637-2.19165-6.24487,2.85547.76733,5.02271,3.2312,5.33374,6.24487ZM10.01245,16.8833c-1.4895-1.53711-2.41895-3.74487-2.58203-6.13135h5.13916c-.16138,2.38818-1.08105,4.59326-2.55713,6.13135ZM7.43066,9.25195c.16284-2.38745,1.0918-4.59399,2.5813-6.13184,1.47681,1.5376,2.39624,3.74292,2.55762,6.13184h-5.13892ZM8.14624,3.00098c-1.28979,1.72021-2.07397,3.91919-2.21509,6.25098h-3.14209c.31177-3.02197,2.49023-5.49072,5.35718-6.25098ZM2.78906,10.75195h3.14209c.14111,2.33081.92627,4.53027,2.21606,6.25098-2.86768-.75977-5.04614-3.22876-5.35815-6.25098ZM11.87671,16.99683c1.27734-1.71924,2.05273-3.91528,2.19238-6.24487h3.14185c-.31104,3.01392-2.47852,5.47778-5.33423,6.24487Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
